import Image from 'next/image';
import { useRef } from 'react';
import SongPlayer from '../SongPlayer/SongPlayer';
import useKaraokePlayer from './useKaraokePlayer.hook';
import { StyledKaraokePlayer } from './KaraokePlayer.styled';
import TranslationsOnImage from '@/shared/TranslationsOnImage/TranslationsOnImage';

export default function KaraokePlayer({
  url,
  onProgress,
  onReady,
  onStart,
  onRestart,
  forceRestart,
  noSeek,
  progressInterval = 50,
  sourceImage,
  currentCue,
  cues,
  showCues,
  onCue,
  pauseOnCue,
  seekTo,
  showPlaybackRate,
  canIncreasePlaybackRate,
  translations,
}) {
  const maskPlayerRef = useRef();
  const karaokeImageRef = useRef();
  const { state, actions } = useKaraokePlayer({
    onReady,
    cues,
    currentCue,
    maskPlayerRef,
    karaokeImageRef,
    onStart,
  });
  return (
    <StyledKaraokePlayer showScroll={state.showScroll}>
      <div ref={maskPlayerRef} className="mask-player">
        <div className="source-image">
          {sourceImage && (
            <>
              <div className="to-be-masked" ref={karaokeImageRef}>
                <Image
                  src={sourceImage}
                  layout={state.imgNaturalSize ? 'responsive' : 'fill'}
                  width={state.imgNaturalSize?.width}
                  height={state.imgNaturalSize?.height}
                  onLoadingComplete={actions.onSourceImageSized}
                  alt=""
                  priority
                  style={
                    state.currentClipPath
                      ? {
                          clipPath: `polygon(${pathPointsToCssPoly(
                            state.currentClipPath.points
                          )})`,
                        }
                      : null
                  }
                />
              </div>
              {state.imgNaturalSize && (
                <div className="onion-bg">
                  <Image
                    src={sourceImage}
                    layout="responsive"
                    width={state.imgNaturalSize.width}
                    height={state.imgNaturalSize.height}
                    alt=""
                  />
                </div>
              )}
            </>
          )}
        </div>
        <TranslationsOnImage
          imgRef={karaokeImageRef}
          translations={translations}
          key={state.scrollTo}
        />
      </div>
      <SongPlayer
        url={url}
        onReady={actions.onPlayerReady}
        onStart={actions.onStart}
        onProgress={onProgress}
        onSeek={actions.onSeek}
        onCue={actions.onCue}
        onRestart={onRestart}
        onPlayPause={actions.onPlayPause}
        forceRestart={forceRestart}
        noSeek={noSeek}
        currentCue={state.currentCue}
        cues={cues}
        seekTo={seekTo}
        progressInterval={progressInterval}
        showCues={showCues}
        showPlaybackRate={showPlaybackRate}
        onFullScreen={actions.onFullScreen}
        fullScreen={state.isFullscreen}
        canIncreasePlaybackRate={canIncreasePlaybackRate}
      />
    </StyledKaraokePlayer>
  );
}

function pathPointsToCssPoly(points) {
  const cssPoly = points.reduce(
    (cssPolyString, point) =>
      cssPolyString
        ? `${cssPolyString}, ${point[0].toFixed(2)}% ${point[1].toFixed(2)}%`
        : `${point[0].toFixed(2)}% ${point[1].toFixed(2)}%`,
    null
  );

  return cssPoly;
}
